<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.bulkInspection_Count">
        <span class="col-form-label">Verify Count</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.bulkInspection_Bag">
        <span class="col-form-label">Correct type of bag for parts</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.bulkInspection_BagMarkings"
      >
        <span class="col-form-label">Compare bag markings vs specsheet</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.bulkInspection_DateCodes">
        <span class="col-form-label">Verify DateCodes/Lotcodes</span>
      </b-form-radio-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'ideaBulk',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        bulkInspection_Count: this.inspectionDetails[FIELDS.BULK_INSPECTION__COUNT] || '',
        bulkInspection_Bag: this.inspectionDetails[FIELDS.BULK_INSPECTION__BAG] || '',
        bulkInspection_BagMarkings: this.inspectionDetails[FIELDS.BULK_INSPECTION__BAG_MARKINGS] || '',
        bulkInspection_DateCodes: this.inspectionDetails[FIELDS.BULK_INSPECTION__DATE_CODES] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>